import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { ScoreCard } from "./ScoreCard"
import { updateKnowledgeScore } from "../../../../store/actions/knowledge.action"

export const ScoreCards = () => {

    const dispatch = useDispatch();

    const { scores } = useSelector(state => state.knowledgeReducer)

    useEffect(() => {
        if (scores.length === 0) {
            dispatch(updateKnowledgeScore())
        }
    }, [])


    if (scores.length === 0) {
        return <></>
    }

    return scores.map(item =>
        <ScoreCard
            competencyCategory={item.competency}
            percentage={item.score}
            title={item.name}
            id={item.id}
            modelType={item.modelType}
        />)

}